module.exports = __webpack_public_path__ + "ATS/img/ic-排名第2.f5e928da.svg";